import { SentimentWordConfig } from './types';

export const jaSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'よい',
        '良い',
        '最高',
        '完成',
        '完了',
        '成功',
        '安全',
        '安定',
        '改善',
        '改良',
        '解決',
        '準備',
        '前進',
        '成長',
        '嬉しい',
        '幸せ',
        '強い',
        '優秀',
        '素晴らしい',
        '便利',
        '有益',
        '明確',
        '安心',
        '健全',
        '支援',
        '勝利',
        '回復',
        '円滑',
        '希望',
        '前向き',
        'うれしい',
        'ありがたい',
        'いきいき',
        'うまくいく',
        'えらい',
        'すっきり',
        'たのしい',
        'できた',
        'はっきり',
        'ほっとする',
        'やさしい',
        'らくらく',
        '安心感',
        '快適',
        '順調',
        '元気',
        '助かる',
        '好き',
        '信頼',
        '前向きだ',
        '達成',
        '頼もしい',
        '励み',
        '満足',
        '見事',
        '良好',
        '有望',
        '価値',
        '復旧',
        '笑顔',
        'あんしん',
        'いける',
        'うきうき',
        'うつくしい',
        'おだやか',
        'かがやく',
        'かんたん',
        'こころよい',
        'さわやか',
        'すばやい',
        'すてき',
        'できる',
        'にこにこ',
        'ほほえみ',
        'まぶしい',
        'めでたい',
        'やわらぐ',
        'わくわく',
        '余裕',
        '充実',
        '助け',
        '吉報',
        '喜び',
        '安らぎ',
        '好調',
        '快い',
        '成就',
        '才能',
        '有効',
        '望ましい',
        '楽',
        '温かい',
        '満たす',
        '素敵',
        '自然',
        '良質',
        '華やか',
        '誇り',
        '頼れる',
        '上出来',
    ]),
    negativeWords: new Set([
        '悪い',
        '最悪',
        '失敗',
        '故障',
        '壊れた',
        '問題',
        '危険',
        '不安',
        '遅延',
        '遅い',
        '緊急',
        'リスク',
        'バグ',
        'エラー',
        '混乱',
        '悲しい',
        '脅威',
        '嫌い',
        '危機',
        '拒否',
        '回帰',
        '停滞',
        '弱い',
        '困難',
        '心配',
        '不調',
        '厄介',
        '悪化',
        '不安定',
        '不具合',
        'あぶない',
        'いらいら',
        'うんざり',
        'おそい',
        'こわい',
        'つらい',
        'ひどい',
        'まずい',
        'もめごと',
        'やっかい',
        '不満',
        '不良',
        '不快',
        '中断',
        '動かない',
        '厳しい',
        '困る',
        '壊れる',
        '嫌だ',
        '心配だ',
        '悲惨',
        '手遅れ',
        '混雑',
        '焦り',
        '疲れ',
        '痛い',
        '破損',
        '緊張',
        '面倒',
        'だめ',
        '圧迫',
        '不便',
        '低下',
        '孤立',
        '重い',
        'あやうい',
        'いけない',
        'うるさい',
        'おびえ',
        'きつい',
        'ぎくしゃく',
        'くたくた',
        'ぐちゃぐちゃ',
        'こまる',
        'しんどい',
        'だるい',
        'つまずき',
        'とげとげしい',
        'のろい',
        'ばらばら',
        'ひやひや',
        'ふあん',
        'へこむ',
        'まずさ',
        'むずかしい',
        'もろい',
        'やばい',
        'わずらわしい',
        '後退',
        '損傷',
        '挫折',
        '消耗',
        '絶望',
        '苦痛',
        '迷惑',
        '遅れ',
        '邪魔',
        '重圧',
        '騒動',
        '冷たい',
    ]),
};
